import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '../components/LanguageSwitcher';
import './LegalPage.css';

type Props = {
  title: string;
  lastUpdated: string;
  children: ReactNode;
};

export function LegalPage({ title, lastUpdated, children }: Props) {
  const { t } = useTranslation();

  return (
    <div className="legal">
      <header className="legal__nav">
        <div className="container legal__nav-inner">
          <Link to="/" className="legal__back">{t('legal.backHome')}</Link>
          <LanguageSwitcher />
        </div>
      </header>
      <article className="container container-narrow legal__article">
        <h1>{title}</h1>
        <p className="legal__updated">{t('legal.lastUpdated', { date: lastUpdated })}</p>
        <div className="legal__content">{children}</div>
      </article>
    </div>
  );
}
